import type { FC } from 'react';
import { Fragment, useMemo } from 'react';
import './index.scss';
import type { StoreScheduleModel } from '@schema/cart';
import clsx from 'clsx';

interface StoreInfoScheduleProps {
  list: StoreScheduleModel[];
  className?: string;
  showTimeOnly?: boolean;
}
const StoreInfoSchedule: FC<StoreInfoScheduleProps> = ({
  list,
  className,
  showTimeOnly
}) => {
  // Не трогай и не вчитывайся
  const result = useMemo(() => {
    if (list) {
      const preparedList = list?.map(a => ({
        ...a,
        day: a.day === 0 ? 7 : a.day
      }));
      preparedList.sort((a, b) => {
        if (Number(a.day) > Number(b.day)) {
          return 1;
        }
        if (Number(a.day) < Number(b.day)) {
          return -1;
        }
        return 0;
      });

      const combineDays = {};
      preparedList?.forEach(a => {
        const name =
          a.status === 'close' ? 'close' : `${a.start_time}_${a.end_time}`;
        if (typeof combineDays[name] === 'undefined') {
          combineDays[name] = [];
        }
        combineDays[name].push(a);
      });

      const daysArr: Array<{
        days: string;
        time: string;
        isClosed: boolean;
      }> = [];
      for (const prop in combineDays) {
        const list = combineDays[prop];
        const days = combineDaysFunc(list);
        const isClosed = prop === 'close';
        const time = isClosed
          ? 'Выходной'
          : showTimeOnly
          ? `${list[0].start_time}:00-${list[0].end_time}:00`
          : `с ${list[0].start_time}:00 до ${list[0].end_time}:00`;
        daysArr.push({
          days: days.join(', '),
          time,
          isClosed
        });
      }
      return daysArr.sort((a, b) => +a?.isClosed - +b?.isClosed);
    }
  }, [list, showTimeOnly]);

  if (!result) {
    return null;
  }
  return (
    <div className={`StoreInfoSchedule ${className || ''}`}>
      <div className='StoreInfoSchedule__row'>
        {result.map((a, i) => (
          <Fragment key={`day-${i}`}>
            {!showTimeOnly && (
              <div className='StoreInfoSchedule__days'>{a.days}:</div>
            )}
            <div
              className={clsx(
                `StoreInfoSchedule__time`,
                a.isClosed && 'StoreInfoSchedule__time--red'
              )}
            >
              {a.time}
            </div>
          </Fragment>
        ))}
      </div>
    </div>
  );
};

export default StoreInfoSchedule;

const DAYS_LIST = ['', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'];

type Days = string[];

const combineDaysFunc = (list: StoreScheduleModel[]): Days => {
  const days: Days = [];
  let isCombined = false;

  list?.forEach((a, i) => {
    const isLast = list.length - 1 === i;

    if (
      // Не первый и не последний день
      !!i &&
      !isLast && // Абсолютная разница между соседними днями == 1
      Number(Math.abs(Number(list[i - 1].day) - Number(a.day))) === 1 &&
      Number(Math.abs(Number(list[i + 1].day) - Number(a.day))) === 1
    ) {
      isCombined = true;
    } else {
      if (isCombined) {
        isCombined = false;
        if (days[days.length - 1]) {
          days[days.length - 1] = `${days[days.length - 1]} - ${
            DAYS_LIST[Number(a.day)]
          }`;
        }
        return;
      }

      isCombined = false;
      days.push(DAYS_LIST[Number(a.day)]);
    }
  });

  return days;
};
